import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueSelectorPlaceholder: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency.issue-selector.issue-selector-placeholder',
		defaultMessage: 'Choose an issue...',
		description: 'Placeholder to show when no search text entered in issue selector',
	},
});
